import { PackagePickerStoreSlice } from './types';
import { reduxKey } from './constants';
import { PapiProductV3 } from '@wix/da-papi-types';

function getState(state: any): PackagePickerStoreSlice {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getPickerStep = (state: any) => getState(state).pickerStep;

export const getPickerMode = (state: any) => getState(state).pickerMode;

export const getPackageProducts = (state: any): PapiProductV3[] =>
  getState(state).packageProducts || [];

export const getPackageBenefits = (state: any) =>
  getState(state).packageBenefits;

export const getPackageConfig = (state: any) => getState(state).packageConfig;

export const getHasProratedDiscountV3 = (state: any) =>
  getPackageProducts(state).some(pkg => pkg.corePackage?.givesProratedDiscount);

export const getFaqs = (state: any) => getState(state).faqs;

export const getSale = (state: any) => getState(state).sale;

export const getGiftUser = (state: any) => getState(state).giftUser;

export const getCurrentCoreSubscriptionV3 = (state: any) =>
  getState(state).currentCoreSuscriptionV3;
